import React, { useState } from 'react'

import Button from 'Components/Button';
import cn from 'classnames'
import cg from 'Scss/app.scss'
import prof from 'Scss/pages/profile.scss'
import btn from 'Components/Button/Button.scss'
import clp from "Scss/pages/profile.scss";
import uiEventEmitter, { UIEvents } from 'Utils/uiEventEmitter';
import Input from 'Components/Input';
import {connect, DispatchProp} from "react-redux";
import ListClient from "Utils/api/ListClient";
import ListItem from "Components/Profile/ShoppingList/components/ListItem";
import Spinner from "Components/Spinner";
import PageLink from 'Components/PageLink';
import {asyncDeleteDialog, Dialog, asyncDialog, showMessage} from "Utils/helpers/modalHelper";
import {refreshShoppingLists, setCart} from "Utils/redux/actions";
import format from 'date-fns/format'
import { CartFragment_cart_products } from 'Utils/api/gql/types';
import { isWaitingForShareDecision } from 'Utils/helpers/shoppingListHelpers';
import SharedListItem from './components/SharedListItem';
import partition from 'lodash/partition'
import ListSharingModal from './ListSharingModal';
import { replaceCartProducts } from 'Utils/api/gql/mutations/replaceCartProducts';
import { getOrCreateCart } from 'Utils/api/gql/helpers';
import _app from 'Pages/_app';
import { SVGEmptyShoppingList } from 'Components/SVGCollection';
import gtmClientInstance from 'Utils/gtmClient';
const  { Router } = require('Utils/routes')

export const SaveCartToListModal: React.FunctionComponent<{cartProducts: CartFragment_cart_products[], callback: (success:boolean) => void }> = (props: { cartProducts: CartFragment_cart_products[], callback: (success:boolean) => void }) => {
  const [title, setTitle] = useState(`Bevásárlás - ${format(Date.now(),'YYYY.MM.DD')}`)
  const [isLoading, setLoading] = useState(false)
  const titleSetter = (e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.currentTarget.value)

  const createList = async () => {
    setLoading(true)
    try {
      const newList = await ListClient.getInstance().createList(title)
      const syncActions = props.cartProducts.map((product) => {
        return { listId: newList.data.listId, productId: parseInt(product.product.id, 10), quantity: product.piece, syncStarted: null, action: "SET_PRODUCT_QUANTITY"}
      })
      await ListClient.getInstance().syncListActions({ actions: syncActions })
      gtmClientInstance.sendEvent("shoppingList", { action: "create" });
      for (let i = 0; i < props.cartProducts.length; i++) {
        gtmClientInstance.sendEvent("shoppingList", { action: "addProduct" });
      }
      setLoading(false)
      props.callback(true)
    } catch {
      setLoading(false)
      props.callback(false)
      return
    }
  }

  return (
    <div>
      <h3 className={cn(cg.textCenter)}>Kosár mentése bevásárlólistának</h3>
      <br />
      <Input autoFocus={true} name="list" type="text" label="Új Lista neve" placeholder={`Bevásárlás - ${format(Date.now(),'YYYY.MM.DD')}`} value={title} onChange={titleSetter} />
      <br />
      <div className={cn(cg.gridX, cg.gridMarginX)}>
        <div className={cn(cg.cell, cg.medium12, cg.textCenter)}>
          <Button
            style={{margin: '5px'}}
            label="Mégsem"
            disabled={isLoading}
            className={cn(btn.secondary, btn.hollow)}
            onClick={() => { uiEventEmitter.emit(UIEvents.CLOSE_MODAL) }}
          />

          <Button
            style={{margin: '5px'}}
            label="Mentés"
            disabled={isLoading || title.length < 5}
            className={cn(btn.secondary)}
            onClick={createList}
          />
        </div>
        <br />
      </div>
    </div>
  )
}

const RenameListModal: React.FunctionComponent<{ list: ShoppingList.IShoppingList, callback: (success:boolean) => void }> = (props: { list: ShoppingList.IShoppingList, callback: (success:boolean) => void }) => {
  const [title, setTitle] = useState(props.list.name)
  const [isLoading, setLoading] = useState(false)
  const titleSetter = (e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.currentTarget.value)

  const createList = async () => {
    setLoading(true)
    try {
      await ListClient.getInstance().updateListNameByListId(props.list.listId, title)
    } catch {
      setLoading(false)
      props.callback(false)
      return
    }
    setLoading(false)
    props.callback(true)
  }

  return (
    <div>
      <h3 className={cn(cg.textCenter)}>Lista átnevezése</h3>
      <br />
      <Input autoFocus={true} name="list" type="text" label="Lista neve" placeholder="Lista neve" maxLength={100} value={title} hideLabel onChange={titleSetter} />
      <br />
      <div className={cn(cg.gridX, cg.gridMarginX)}>
        <div className={cn(cg.cell, cg.medium12, cg.textCenter)}>
          <Button
            style={{margin: '5px'}}
            label="Mégsem"
            disabled={isLoading}
            className={cn(btn.secondary, btn.hollow)}
            onClick={() => { uiEventEmitter.emit(UIEvents.CLOSE_MODAL) }}
          />

          <Button
            style={{margin: '5px'}}
            label="Átnevezés"
            disabled={isLoading || title.length < 5 || title === props.list.name}
            className={cn(btn.secondary)}
            onClick={createList}
          />
        </div>
        <br />
      </div>
    </div>
  )
}

const NewListModal: React.FunctionComponent = () => {
  const [title, setTitle] = useState('')
  const [isLoading, setLoading] = useState(false)
  const titleSetter = (e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.currentTarget.value)

  const createList = async () => {
    setLoading(true)
    try {
      await ListClient.getInstance().createList(title)
    } catch {
      setLoading(false)
      return
    }
    setLoading(false)
    uiEventEmitter.emit(UIEvents.CLOSE_MODAL)
  }

  return (
    <div>
      <h3 className={cn(cg.textCenter)}>Új lista hozzáadása</h3>
      <br />
      <Input autoFocus={true} name="list" type="text" label="Lista neve" placeholder="Lista neve" value={title} hideLabel onChange={titleSetter} />
      <br />
      <div className={cn(cg.gridX, cg.gridMarginX)}>
        <div className={cn(cg.cell, cg.medium12, cg.textCenter)}>
          <Button
            style={{margin: '5px'}}
            label="Mégsem"
            disabled={isLoading}
            className={cn(btn.secondary, btn.hollow)}
            onClick={() => { uiEventEmitter.emit(UIEvents.CLOSE_MODAL) }}
          />

          <Button
            style={{margin: '5px'}}
            label="Létrehozás"
            disabled={isLoading || title.length < 5}
            className={cn(btn.secondary)}
            onClick={createList}
          />
        </div>
        <br />
      </div>
    </div>
  )
}


type ReduxPropType = {
  userId: string | null
  shoppingLists: Redux.IShoppingListState
}

type OwnProps = {
  selectedListId?: string
}

class ShoppingListView extends React.Component<ReduxPropType & OwnProps & DispatchProp> {

  componentDidMount(): void {
    this.refetchLists()
  }

  componentDidUpdate(): void {
    uiEventEmitter.emit(UIEvents.END_LOADING)
  }

  refetchLists = () => {
    uiEventEmitter.emit(UIEvents.START_LOADING)
    this.props.dispatch(refreshShoppingLists())
  }

  onDeleteList = async (list: ShoppingList.IShoppingList) => {
    if (await asyncDeleteDialog(`Biztos törlöd a ${list.name} nevű listádat?`) !== 'yes') {
      return
    }
    try {
      await ListClient.getInstance().removeListById(list.listId)
    } catch {

    }
    this.refetchLists()
  }

  onLeaveList = async (list: ShoppingList.IShoppingList) => {
    const leaveDialogConfig: Dialog<'yes' | 'no'> = {
      message: `Biztos elhagyod a ${list.name} nevű listát?`,
      buttons: [
          { label: 'Mégsem', value: 'no', className: btn.hollow },
          { label: 'Lista elhagyása', value: 'yes', className: btn.primary }
      ]
  }
    if (await asyncDialog(leaveDialogConfig) !== 'yes') {
      return
    }
    try {
      uiEventEmitter.emit(UIEvents.START_LOADING)
      await ListClient.getInstance().leaveListById(list.listId)
    } catch {

    }
    this.refetchLists()
  }

  onRenameListResult = (wasSuccess: boolean) => {
    uiEventEmitter.emit(UIEvents.CLOSE_MODAL)
    if (wasSuccess) {
      this.refetchLists()
    }
  }

  onAcceptSharing = async (list: ShoppingList.IShoppingList) => {
    try {
      uiEventEmitter.emit(UIEvents.START_LOADING)
      await ListClient.getInstance().acceptShare(list.listId)
    } catch {

    }
    this.refetchLists()
  }

  onDeclineSharing = async (list: ShoppingList.IShoppingList) => {
    try {
      uiEventEmitter.emit(UIEvents.START_LOADING)
      await ListClient.getInstance().declineShare(list.listId)
    } catch {

    }
    this.refetchLists()
  }

  onSharingClick = (list: ShoppingList.IShoppingList) => {
    uiEventEmitter.emit(UIEvents.SHOW_MODAL, <ListSharingModal listId={list.listId}/>)
  }

  onAddToCartClick = async (list: ShoppingList.IShoppingList) => {
    try {
      uiEventEmitter.emit(UIEvents.START_LOADING)
      const data = list.products.map(product => {
        return { product_id: product.productId, piece: product.quantity }
      })
      await _app.apolloClient.mutate({mutation: replaceCartProducts, variables: {products: data}})
      const nextCartData = await getOrCreateCart(_app.apolloClient, undefined)
      this.props.dispatch(setCart(nextCartData))
      gtmClientInstance.addShoppingListProductsToCart(list.products, nextCartData);
      showMessage('A lista termékei bekerültek a kosárba!')
    } catch {

    }
    uiEventEmitter.emit(UIEvents.END_LOADING)
  }

  renderFetching = () => {
    return (
      <div style={{ minHeight: 200, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <Spinner/>
      </div>
    )
  }

  renderNoLists = () => {
    return (
      <div className={cn(clp.emptyContainer, cg.textCenter)}>
        <SVGEmptyShoppingList width={80} height={80} style={{ color: '#00a3e0' }} />
        <p>
          Nincsenek listáid <br />
          Hozz létre egyet!
        </p>
      </div>
    )
  }

  renderLists = () => {
    const [sharedList, otherLists] = partition(this.props.shoppingLists.lists, (list) => isWaitingForShareDecision(this.props.userId!, list))

    return (
      <React.Fragment>
        {(sharedList.map(list => {
          return (
            <SharedListItem list={list} key={`shoppinglist_${list.listId}`}
              onAcceptShare={this.onAcceptSharing}
              onDeclineShare={this.onDeclineSharing}
            />
          )
        }))}
        {(otherLists.map(list => {
          return (
            <ListItem list={list} key={`shoppinglist_${list.listId}`}
                      allLists={this.props.shoppingLists.lists}
                      userId={this.props.userId!}
                      onClick={(list: ShoppingList.IShoppingList) => { Router.pushRoute(`/profil/bevasarlolistaim/${list.listId}`) }}
                      onRenameClick={(list: ShoppingList.IShoppingList) => uiEventEmitter.emit(UIEvents.SHOW_MODAL, <RenameListModal list={list} callback={this.onRenameListResult} />)}
                      onDeleteListClick={this.onDeleteList}
                      onLeaveListClick={this.onLeaveList}
                      onSharingClick={this.onSharingClick}
                      onAddToCartClick={this.onAddToCartClick}
            />
          )
        }))}
      </React.Fragment>
    )
  }

  render () {
    if (this.props.userId === null) { return null }
    if (!this.props.shoppingLists.isFetched && this.props.shoppingLists.isFetching) {
      return this.renderFetching()
    }

    const lists = this.props.shoppingLists.lists.length === 0 ? this.renderNoLists() : this.renderLists()

    return (
      <div>
        <h3 className={cn(prof.title, cg.gridX, cg.alignMiddle, cg.showForMedium)}>
            <span className={cn(cg.cell, cg.auto)}>
              Bevásárlólistáim
            </span>
            <span className={cn(cg.cell, cg.shrink)}>
              <Button className={cn(btn.link)} label="+ Új lista létrehozása" onClick={() => uiEventEmitter.emit(UIEvents.SHOW_MODAL, <NewListModal />, this.refetchLists)} />
            </span>
        </h3>
        <div className={cn(cg.gridX, cg.alignMiddle, cg.hideForMedium)} style={{marginTop: '20px', marginBottom: '20px'}}>
          <div className={cn(cg.cell, cg.auto, cg.textCenter)}>
            <Button className={cn(btn.link)} label="+ Új lista létrehozása" onClick={() => uiEventEmitter.emit(UIEvents.SHOW_MODAL, <NewListModal />, this.refetchLists)} />
          </div>
        </div>
        {lists}
      </div>
    )
  }
}

const mapStateToProps = (state: Redux.IReduxState) => {
  const userId = state.session.loggedIn ? state.session.customerData.id : null
  return {
    userId,
    shoppingLists: state.shoppingLists
  }
}

export default connect(mapStateToProps)(ShoppingListView)
